// extracted by mini-css-extract-plugin
export var searchHeader = "_9o-0";
export var searchHeaderDark = "_9o-1";